import React from "react";
import axios from "../general/HttpClient";

let fetched = false;
let referenceData = {};

export function GetReferenceData() {
    if (fetched) {
        return Promise.resolve(referenceData);
    }
    return axios.get(`/api/ReferenceData/static`).then((response) => {
        referenceData = response.data.result;
        fetched = true;
        return response.data.result;
    });
}

GetReferenceData();

export function reference(type, code) {
    return referenceData[type].filter((r) => r.value == code || r.name == code)[0].displayName;
}

export function useReferenceData(type) {
    const [referenceData, setReferenceData] = React.useState([]);

    React.useEffect(() => {
        GetReferenceData().then((res) => {
            setReferenceData(res[type]);
        });
    }, []);

    return referenceData;
}
